<template>
    <div>
       <div class='top'>
          <a-input v-model:value="searchValue" placeholder="姓名/手机号" allowClear class='ainput' @pressEnter='searchAction' @change='clear'/>
          <a-button type="primary" class='submitBtn' @click='searchAction'>
            查询
          </a-button>

          <a-button type="primary" class='addBtn' @click='addUserAction'>
            新增
          </a-button>
       </div>

        <a-spin :spinning="loadingTag">
            <div class='content'>
                <a-row class="title">
                    <a-col :span='2' style='text-align:left;'>
                        姓名
                    </a-col>
                    <a-col :span='3'>
                        状态
                    </a-col>
                    <a-col :span='3'>
                        乘客类型
                    </a-col>
                    <a-col :span='7'>
                        证件号码
                    </a-col>
                    <a-col :span='5'>
                        手机号码
                    </a-col>
                    <a-col :span='4'>
                        操作
                    </a-col>
                </a-row>
                <div class='title bgw' v-for='(item,index) in list' :key='index'>
                    <a-row class="rows" :class='{noBorder:index == list.length - 1 }'>
                        <a-col :span='2' style='text-align:left;'>
                            {{item.name}}
                        </a-col>
                        <a-col :span='3' class='grey regular'>
                            <span v-if='item.state == 20'>{{item.stateValue}}</span>
                            <span v-else style='color:red'>{{item.stateValue}}</span>
                        </a-col>
                        <a-col :span='3' class='grey regular'>
                            {{item.passengerTypeValue}}
                        </a-col>
                        <a-col :span='7' class='grey regular'>
                            {{item.cardNo}}
                        </a-col>
                        <a-col :span='5' class='grey regular'>
                            {{item.mobile}}
                        </a-col>
                        <a-col :span='4' class='operation regular'>
                            <span @click="editUser(index)">编辑</span>
                            <span @click='deleteUser(index)'>删除</span>
                        </a-col>
                    </a-row>
                </div>
                <a-empty
                    :description="'～您还没有添加联系人～'"
                    v-show="!list.length && !loadingTag"
                    style="margin:50px 0;"
                />
            </div>
            <a-pagination 
                v-show='list.length'
                v-model:current="current" 
                :total="total" 
                :page-size='8'
                @change='pageChange'
                :show-total="(total, range) => `第${range[0]}条 - 第${range[1]}条  共 ${total} 条`"
            
            />
        </a-spin>

        <a-modal
            title="Title"
            v-model:visible="addvisible"
            :footer='null'
            :closable='false'
            :keyboard='false'
            :maskClosable='false'
            >
            
            <div class='add_content'>
                <a-form :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" :ref="torefs">
                    <div class='form_title'>
                        {{editid?'编辑':'创建'}}乘客
                    </div>
                    <a-form-item label="乘客类型：" class='bdbtm1'  name='passengerType'>
                        <a-radio-group v-model:value="form.passengerType" button-style="solid" :disabled="editid != '' && editState == 20">
                            <a-radio-button  v-for='(item,index) in typeList' :key='index' :value="item.val">
                                {{item.name}}
                            </a-radio-button>
                         
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item label="证件类型：" class='bdbtm1 required'  name='cardType'>
                        <a-select
                            v-model:value="form.cardType"
                            style="width: 320px"
                            :placeholder='"请选择证件类型"'
                            size='small'
                            :disabled="editid != '' && editState == 20"
                            >
                            <a-select-option v-for='(item,index) in cardType' :key='index' :value="item.val" >
                                {{item.name}}
                            </a-select-option>
                         

                        </a-select>
                    </a-form-item>

                    <a-form-item label="乘客姓名：" class='bdbtm1' name='name'>
                        <a-input v-model:value="form.name" placeholder="请填写乘客姓名" style="width: 320px" :disabled="editid != '' && editState == 20"/>
                    </a-form-item>

                    <a-form-item label="乘客性别：" class='bdbtm1' name='sex' v-if='form.cardType && form.cardType != 1'>
                        <a-radio-group v-model:value="form.sex" button-style="solid">
                            <a-radio-button  value="M">
                                男
                            </a-radio-button>
                            <a-radio-button  value="F">
                                女
                            </a-radio-button>
                         
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="乘客生日：" class='bdbtm1 required' name='birthday' v-if='form.cardType && form.cardType != 1' >
                        <a-date-picker
                            v-model:value="form.birthday"
                            :disabled="editid != '' && editState == 20"
                            type="date"
                            placeholder="选择生日"
                            valueFormat='YYYY-MM-DD'
                            :disabled-date="disabledDate"
                            style="width: 320px"
                        />
                    </a-form-item>

                    <a-form-item label="证件号码：" class='bdbtm1' name='cardNo'>
                        <a-input v-model:value="form.cardNo" placeholder="请填写证件号码" style="width: 320px" :disabled="editid != '' && editState == 20"/>
                    </a-form-item>
                    <a-form-item label="手机号码：" class='bdbtm1' name='mobile'>
                        <a-input v-model:value="form.mobile" placeholder="请填写手机号码" style="width: 320px"/>
                    </a-form-item>
                    <a-form-item label="电子邮箱：" class='bdbtm1 required' name='email' v-if='form.cardType && form.cardType != 1'>
                        <a-input v-model:value="form.email" placeholder="请填写邮箱" style="width: 320px"/>
                    </a-form-item>

                    <a-form-item >
                        <a-button type="primary" class='add_submit' @click='submitAddUser' :loading='loading'>
                            {{editid?'编辑':'添加'}}乘客
                        </a-button>
                    </a-form-item>
                </a-form>
                <div class='close_add' @click='addvisible = false'>
                    <CloseCircleOutlined :style='{fontSize:"20px"}'/>
                </div>
            </div>
        </a-modal>




    </div>
</template>
<script>
import { ref, watch } from 'vue'
import myApi from '@axios/my'
import { CloseCircleOutlined } from '@ant-design/icons-vue';
import { message,Modal } from 'ant-design-vue'

export default {
  name: 'passenger',
  components: {
    CloseCircleOutlined,
  },
  setup () {
    let checkPhone = async (rule, value) => {
        if (!value) {
            return Promise.reject('手机号不能为空');
        } else {
            const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
            if (reg.test(value)) {
                Promise.resolve();
            } else {
                return Promise.reject('请输入正确的手机号');
            }
        }
    };

    let checkDistributorId = (rule, value, callback) => {
        if (!value) {
            return Promise.reject('请选择证件类型');
        } else {
            return Promise.resolve();
        }
    };
    let searchValue = ref('');
    let list = ref([])
    let loadingTag = ref(false)
    let current = ref(1);
    let total = ref(0);
    const getUserList = () => {
        loadingTag.value = true
        myApi.getUserList({
            name : searchValue.value?searchValue.value:null,
            size: 10,
            currentPage: current.value,
            sourceType: 1

        }).then((res)=>{
            loadingTag.value = false
            current.value = res.page;
            total.value = res.total;
            list.value = res.data;

        }).catch(()=>{
            loadingTag.value = false
        })
    }

    let addvisible = ref(false);
    let form = ref({
        passengerType : 1,
        cardType : undefined,
        name : '',
        cardNo : '',
        mobile : '',
        sex : 'M',
        birthday : undefined

    })

    let itemrefs = [];
    const torefs = (el) => {
        itemrefs.push(el)
    }

    getUserList();

    let loading = ref(false);
    let editid = ref('')

    const addUserAction = () => {
        form.value.passengerType = 1;
        form.value.cardType = undefined;
        form.value.name = '';
        form.value.cardNo = '';
        form.value.mobile = '';
        form.value.email = '';
        
        form.value.sex = 'M'
        form.value.birthday = undefined
        addvisible.value = true;
        editid.value = ''
     
    }
    let editState = ref(false);

    const editUser = (index) => {
        editid.value =  list.value[index].id;
        editState.value = list.value[index].state;
        form.value.passengerType = parseInt(list.value[index].passengerType);
        form.value.cardType = parseInt(list.value[index].cardType);
        form.value.name = list.value[index].name;
        form.value.sex = list.value[index].sex || 'M';
        form.value.birthday = list.value[index].birthday
        form.value.email = list.value[index].email;
        if(list.value[index].cardNoValue){
            form.value.cardNo = list.value[index].cardNoValue;
        }else{
            form.value.cardNo = list.value[index].cardNo;
        }
        
        form.value.mobile = list.value[index].mobileValue;
        
        addvisible.value = true;
    }

    const submitAddUser = () => {
        itemrefs[0].validate().then(()=>{
            console.log(1)
            //验证规则是否合法
            loading.value = true;
            let params = {
                name : form.value.name,
                passengerType : form.value.passengerType,
                cardNo : form.value.cardNo,
                mobile : form.value.mobile,
                cardType : form.value.cardType,
                sex : form.value.cardType != 1?form.value.sex:null,
                birthday : form.value.birthday,
                email : form.value.email,
                sourceType: 1
            }
            if(editid.value){
                params.id = editid.value;
                myApi.editUser(params).then((res)=>{
                    loading.value = false;
                    addvisible.value = false;
                    message.success('修改成功')
                    getUserList();
                }).catch(err=>{
                    loading.value = false;
                })
            }else{
                myApi.addUser(params).then((res)=>{
                    loading.value = false;
                    addvisible.value = false;
                    message.success('添加成功')
                    getUserList();
                }).catch(err=>{
                    loading.value = false;
                })
            }
            
        }).catch(err=>{
            loading.value = false;
        })
    }

    //添加编辑刷新删除乘客逻辑相关
    const typeList = ref([
        {
            name : '成人',
            val : 1
        },
        {
            name : '儿童',
            val : 2
        },
        {
            name : '学生',
            val : 3
        },
        {
            name : '残军',
            val : 4
        }
    ])
    const cardType = ref([
        {
            name : '中国居民身份证',
            val : 1
        },
        {
            name : '护照',
            val : 2
        },
        {
            name : '台湾居民来往大陆通行证',
            val : 3
        },
        {
            name : '港澳居民来往内地通行证',
            val : 4
        },
        {
            name : '外国人永久居留身份证',
            val : 5
        },
        {
            name : '港澳台居民居住证',
            val : 6
        },
 
    ])

    const deleteUser = (index) => {
        Modal.confirm({
            content: "请确定删除" + list.value[index].name + '?',
            onOk() {
                myApi.delUser(list.value[index].id).then((res)=>{
                    message.success('删除成功')
                    getUserList()
                })
            },
            cancelText: "取消",
            okText: "确定",
            onCancel() {
                Modal.destroyAll();
            },
        });
    }


    let birthday = (rule, value, callback) => {
        if (!value && form.value.cardType != 1) {
            return Promise.reject('请选择生日');
        } else {
            return Promise.resolve();
        }
    };


    let email = (rule, value, callback) => {
        if (!value && form.value.cardType != 1) {
            return Promise.reject('请输入邮箱');
        } else {
            return Promise.resolve();
        }
    };

    const searchAction = () => {
        current.value = 1;
        total.value = 0;
        getUserList();
    }
    
    const clear = (val) => {
        current.value = 1;
        total.value = 0;
        if(!searchValue.value){
            getUserList();
        }
    }

      
    const pageChange = (page) => {
      current.value = page;
      getOrderList();
    }



    const disabledDate = (current) => {
      return current > moment().add(-1, 'd') 
    }



    return {
        disabledDate,
      current,
      total,
      pageChange,
      clear,
      searchAction,
      loadingTag,
      editState,
      editUser,
      deleteUser,
      submitAddUser,
      typeList,
      cardType,
      loading,
      editid,
      form,
      addvisible,
      searchValue,
      list,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      torefs,
      addUserAction,
      rules : {
          cardType: [
              { validator: checkDistributorId, trigger: 'blur' },
          ],
          name: [
              { required: true, message: '请输入乘客姓名', trigger: 'blur' },
          ],
          cardNo: [
              { required: true, message: '请输入证件号码', trigger: 'blur' },
          ],
          mobile: [
              { required: true, message: '请输入电话号码', trigger: 'blur' },
              { validator: checkPhone, trigger: 'blur' }
          ],
            birthday: [
                { validator: birthday, trigger: 'change' ,type: 'object'},
                
            ],
            email: [
                { validator: email, trigger: 'blur' ,type: 'object'},
                
            ],
            
      }
    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .regular{

        font-size: 14px!important;
        font-family: PingFangSC-Regular, PingFang SC!important;
        font-weight: 400!important;
    }
    .form_title{

        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        padding-left:10px;
        padding-bottom:12px;
        margin-top: 20px;
        border-bottom: 3px solid #CDCCCD;
        margin-bottom: 10px;
    }
    .ainput{
        width: 220px!important;
    }
  .bdbtm1{
      border-bottom: 0.5px solid #CDCCCD;
      padding-bottom:10px ;
      margin-bottom: 10px;
  }
  .add_submit{
      width: 144px;
      height: 40px;
      line-height: 40px;
      background: #FFAB00;
      border-color:#FFAB00 ;
      border-radius: 5px;
      margin-left: 10px;
      margin-top: 20px;
  }
  .close_add{
      position: absolute;
      top:43px;
      right: 20px;
      cursor: pointer;
  }

  .noBorder{
    border: none!important;
  }

  .bgw{
    background: #fff!important;
    height: auto!important;
  }
  .bgw:hover{
    background: #e6f7ff!important;
    .rows{
      background: #e6f7ff!important;
    }
  }
  .grey{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6C7279;
  }
  .operation{
    display: flex;
    justify-content:center;
    color:#6D7278;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    text-decoration: underline;
    span{
      cursor: pointer;
      margin:0 15px;
    }
  }
  .rows{
    background: #fff!important;
    border-bottom:1px solid #DBDCE0;
    box-sizing: border-box;
  }
  .top{
    // height: 55px;
    background: #F8F8F8;
    padding: 13px 19px;
    border-radius: 2px;
    display: flex;
    justify-content: flex-start;

  }

    .submitBtn{
        background: #FFAB00;
        border-color:#FFAB00;
        margin-left: 17px;
        width:101px;

        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        border-radius: 4px;
    }
    .addBtn{
        background: #DBDCE0;
        border-color:#DBDCE0;
        color:#000000;
        margin-left: 17px;
        width:101px;
        color: #000000;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 300;
        letter-spacing: 1px;

    }

  .content{
      border-radius: 2px;
      border: 0.5px solid #DBDCE0;
      margin-top: 17px;
  }
  .title{
      background: #F8F8F8;
      height: 55px;
      line-height: 55px;
      padding: 0 18px;
  }

    .title{
        ::v-deep(.ant-col){
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
        }
    }


  .add_content{
      padding:20px;
      // background: #F8F8F8;
      border:0.5px solid #CDCCCD;
  }
  .delete_passengers{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      div{
          cursor: pointer;
      }
      
  }
  .addchildredn{
      color:#FD5739;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      cursor: pointer;
      img{
          margin-right: 8px;
      }
  }

  .add_content{
    ::v-deep(.ant-select-selection--single) {
        height: 32px !important;
    }
  }


  .add_content{
    ::v-deep(.ant-select-selection__rendered){
        line-height: 32px !important;
    }
  }


  



</style>
